import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient, type RequestBody } from '../client';
import { queryKeys } from '../react-query.config';

type UpdateUsernamePayload = RequestBody<'/api/username', 'put'>;

export const useUpdateUsername = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['updateUsername'],
    mutationFn: async (data: UpdateUsernamePayload) => {
      console.log('[useUpdateUsername] 🚀 Mutation function called with data:', data);
      console.log('[useUpdateUsername] 🌐 Making PUT request to /api/username');
      const result = await apiClient.put('/api/username', data);
      console.log('[useUpdateUsername] ✅ PUT request successful, response:', result);
      return result;
    },
    onSuccess: async data => {
      console.log('[useUpdateUsername] ✅ Mutation onSuccess callback triggered');
      console.log('[useUpdateUsername] 📝 Response data:', data);
      console.log('[useUpdateUsername] 🔄 Invalidating user details query...');
      await queryClient.invalidateQueries({
        queryKey: queryKeys.user.details(),
      });
      console.log('[useUpdateUsername] ✅ User details query invalidated');
    },
    onError: error => {
      console.error('[useUpdateUsername] ❌ Mutation onError callback triggered');
      console.error('[useUpdateUsername] ❌ Error:', error);
    },
  });
};
